import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { isAuthenticated, hasPermission} from '../services/authService';

// Protected route wrapper - requires authentication
export const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export const PermissionRoute = ({ children, resource, action }) => {
  const navigate = useNavigate(); 
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(resource, action)) {
    return (
      <div
        style={{
          padding: '40px',
          textAlign: 'center',
          backgroundColor: '#fff',
          margin: '20px',
          borderRadius: '4px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >
        <h2 style={{ color: '#dc3545', marginBottom: '16px' }}>
          Access Denied
        </h2>
        <p style={{ color: '#666' }}>
          You don't have permission to access this page.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
